import { Helmet } from "react-helmet";

interface PageMetaProps {
  title: string;
  description: string;
}

export function usePageMeta({ title, description }: PageMetaProps) {
  return (
    <Helmet>
      <title>{title} | Martin Townsend Postal History</title>
      <meta name="description" content={description} />
    </Helmet>
  );
}

// Static page meta data
export const staticPageMeta = {
  About: {
    title: "About Us",
    description:
      "Learn about Martin Townsend's expertise in postal history and philatelic materials. Discover our commitment to authentic historical postal items and exceptional customer service.",
  },
  Contact: {
    title: "Contact Us",
    description:
      "Get in touch with Martin Townsend for inquiries about postal history items, valuations, or general questions. We're here to help with your philatelic needs.",
  },
  Payment: {
    title: "Payment Information",
    description:
      "Secure payment options for Martin Townsend postal history items. Learn about our accepted payment methods and secure checkout process.",
  },
  Delivery: {
    title: "Delivery Information",
    description:
      "Shipping and delivery information for Martin Townsend postal history orders. Fast, secure delivery worldwide with tracking and insurance options.",
  },
  Guarantee: {
    title: "Our Guarantee",
    description:
      "Martin Townsend's guarantee on all postal history items. Learn about our authenticity guarantee, return policy, and commitment to customer satisfaction.",
  },
  Terms: {
    title: "Terms & Conditions",
    description:
      "Terms and conditions for purchasing from Martin Townsend postal history. Important information about orders, returns, and our policies.",
  },
  Valuation: {
    title: "Valuation Services",
    description:
      "Professional postal history and stamp valuation services from Martin Townsend. Expert appraisals for insurance, sale, or collection purposes.",
  },
};
